// extracted by mini-css-extract-plugin
export default {"dialog":"ModulesContainer_dialog__tlf9n","settings":"ModulesContainer_settings__1wBaO"};